module.exports = __webpack_public_path__ + "static/media/line.c96b7165.gif";